import { format } from "date-fns";

export const formatToJst = (date: string | Date): string =>
  format(new Date(date), "yyyy-MM-dd'T'HH:mm:00+09:00");

export const formatDateTime = (date: string | Date | null | undefined): string | null => {
  if (!date) return null;
  try {
    return format(new Date(date), "dd MMM yyyy HH:mm");
  } catch {
    return null;
  }
};
